import React, { useCallback } from "react";

import { motion, useReducedMotion } from "framer-motion";
import { MENU_SCREEN } from "../../../../menu.types";
import leftSidebarItems from "../../constants/leftSidebarItems";
import NavItem from "./NavItem";
import { SidebarItem } from "../../constants/leftSidebarItems";

interface LeftSidebarProps {
  activeScreen: MENU_SCREEN;
  changeScreen: (screen: MENU_SCREEN) => void;
}

declare const mp: { trigger: (event: string, ...args: any[]) => void };

const staggerContainer: any = {
  hidden: {},
  visible: {
    // was delayChildren: 0.32 — items now start at 0s (parent slide handles visual delay)
    transition: { staggerChildren: 0.05, delayChildren: 0 },
  },
};

const navItemEntrance: any = {
  hidden: { opacity: 0, x: -20 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.35, ease: [0.22, 1, 0.36, 1] },
  },
};

const LeftSidebar: React.FC<LeftSidebarProps> = ({
  changeScreen,
  activeScreen,
}) => {
  const shouldReduceMotion = useReducedMotion();

  const handleNavItemClick = useCallback(
    (item: SidebarItem) => {
      if (item.screen) {
        changeScreen(item.screen);
      } else if (item.redirectTo) {
        try {
          mp.trigger("openUrl", item.redirectTo);
        } catch {
          window.open(item.redirectTo, "_blank");
        }
      }
    },
    [changeScreen],
  );

  return (
    <motion.nav
      className="flex flex-col items-stretch gap-3 w-full max-w-[330px]"
      {...(shouldReduceMotion
        ? {}
        : {
            variants: staggerContainer,
            initial: "hidden",
            animate: "visible",
          })}
    >
      {leftSidebarItems.map((item) => (
        <motion.div
          key={item.id}
          {...(shouldReduceMotion ? {} : { variants: navItemEntrance })}
        >
          <NavItem
            item={item}
            highlight={activeScreen === MENU_SCREEN.Profile}
            onClick={handleNavItemClick}
          />
        </motion.div>
      ))}
    </motion.nav>
  );
};

export default LeftSidebar;
